<section class="med_section d-flex flex-column w-100">
  <!-- HEADER -->
  <!-- Desktop & Tablet view -->
  @if (deviceType.isDesktop) {
    <app-header-bar>
      <ng-container header-left>
        <div class="d-flex justify-content-start align-items-center gap-2">
          <h1 class="s-title bold" data-cy="med_spaces_title">{{ "spaces" | translate | titlecase }}</h1>
          @if (spacesStore.spacesCount() > 0) {
            <p class="xl-body">({{ spacesStore.spacesCount() }})</p>
          }
          <button
            class="btn btn-clean p-0"
            (click)="refreshSpaces()"
            pTooltip="{{ 'refresh_spaces' | translate }}"
            tooltipPosition="right"
            data-cy="med_refresh_spaces_btn"
            showDelay="500"
          >
            <app-icon icon="arrow-rotate-right" class="icon-light" />
          </button>
        </div>
      </ng-container>
      <ng-container header-right>
        <!-- Filter by tag -->
        <button
          class="med_sort-btn border-0 rounded-pill l-body d-flex justify-content-between align-items-center text-capitalize gap-2 py-0 pe-3 ps-3"
          mat-button
          [matMenuTriggerFor]="spaceTags"
        >
          <app-icon icon="tag" class="icon-active"></app-icon>
          @if (
            spacesStore.userTags().length == spacesStore.tagsFilterList().length ||
            spacesStore.tagsFilterList().length === 0
          ) {
            <span class="l-body">{{ "all_tags" | translate }}</span>
          } @else {
            <span class="l-body">{{ spacesStore.tagsFilterList().length }} {{ "tags" | translate }}</span>
          }
          <app-icon icon="chevron-down" />
        </button>
        <mat-menu #spaceTags="matMenu" class="med_filter-dropdown">
          <div class="med_tag-header med_tag-header-bg p-2" (click)="$event.stopPropagation()">
            <input
              type="text"
              class="med_tag-search form-control border-0"
              placeholder="{{ 'search_tag' | translate }}"
              (input)="onSpaceTagsFilterMenuInput($event)"
            />
          </div>
          <div class="med_tags vstack gap-2 p-3">
            <div class="form-check" (click)="toggleSelectAll(); $event.stopPropagation()">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                [checked]="spacesStore.userTags().length == spacesStore.tagsFilterList().length"
              />
              <label class="form-check-label">
                <span class="med_tag">{{ "all" | translate }}</span>
              </label>
            </div>
            @for (tag of filteredTags(); track tag.uuid) {
              <div class="form-check" (click)="toggleSelectedTagFilter(tag); $event.stopPropagation()">
                <input
                  class="form-check-input"
                  [checked]="getIsTagSelected(tag.uuid)"
                  type="checkbox"
                  value=""
                  [id]="'tag' + tag.uuid"
                />
                <label class="form-check-label">
                  <span
                    class="med_tag d-block py-0 text-truncate"
                    #tagElement
                    [matTooltip]="getTooltipText(tag.name, tagElement)"
                    matTooltipPosition="above"
                    [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
                    >{{ tag.name }}</span
                  >
                </label>
              </div>
            }
          </div>
        </mat-menu>
        <!-- #Filter by tag -->

        <!-- Sort by time and name -->
        <!--<button
        class="med_sort-btn border-0 rounded-pill l-body d-flex justify-content-between align-items-center text-capitalize gap-2 py-0 pe-2 ps-3"
        mat-button
        [matMenuTriggerFor]="belowMenu"
      >
        <app-icon icon="sort" class="icon-active"></app-icon>
        <span class="l-body">{{ spacesStore.selectedSortOption().value | translate | titlecase }}</span>
        <app-icon icon="chevron-down" />
      </button>
      <mat-menu #belowMenu="matMenu" class="med_filter-dropdown">
        @for (option of sortOptions; let i = $index; track $index) {
        <button
          mat-menu-item
          (click)="sortSpacesByOption(option.value)"
          [class.active]="option.value === spacesStore.selectedSortOption().value"
          [attr.data-index]="i"
        >
          <span class="l-body text-capitalize">{{ option.label }}</span>
        </button>
        }
      </mat-menu>-->
        <!-- #Sort by time and name -->

        <!-- Sort by role -->
        <!--<button
        class="med_sort-btn border-0 rounded-pill l-body d-flex justify-content-between align-items-center text-capitalize gap-2 py-0 pe-2 ps-3"
        mat-button
        [matMenuTriggerFor]="sortRolesMenu"
      >
        <app-icon icon="filter" class="icon-active"></app-icon>
        <span class="l-body">{{ spacesStore.selectedRole().label | translate }}</span>
        <app-icon icon="chevron-down" />
      </button>
      <mat-menu #sortRolesMenu="matMenu" class="med_filter-dropdown">
        @for (option of usersRoles; let i = $index; track $index) {
        <button
          mat-menu-item
          (click)="filterSpacesByRole(option.value)"
          [class.active]="option.value === spacesStore.selectedRole().value"
          [attr.data-index]="i"
        >
          <span class="l-body text-capitalize">{{ option.label }}</span>
        </button>
        }
      </mat-menu>-->
        <!-- #Sort by role -->

        <!-- Spaces search filter -->
        <div class="input-group med_search">
          <span class="input-group-text border-0">
            <app-icon icon="magnifying-glass" />
          </span>
          <input
            [type]="'text'"
            class="form-control border-0 ps-0"
            placeholder="{{ 'search_space' | translate }}..."
            data-cy="med_search_space_input"
            [(ngModel)]="spaceFilter"
          />
          <span class="input-group-text border-0">
            <div class="med_empty-button border-0 d-flex justify-content-center align-items-center">
              @if (spaceFilter) {
                <app-icon icon="xmark" (click)="spaceFilter = ''" class="cursor-pointer"></app-icon>
              }
            </div>
          </span>
        </div>

        <div class="hstack">
          <!-- SORT DROPDOWN -->
          <div ngbDropdown class="med_sort-filter">
            <button
              type="button"
              class="btn btn-clean px-2"
              id="dropdownSort"
              ngbDropdownToggle
              (click)="$event.stopPropagation()"
            >
              <app-icon icon="arrow-down-arrow-up" class="icon-md icon-active"></app-icon>
            </button>

            <div ngbDropdownMenu aria-labelledby="dropdownSort">
              @for (option of sortOptions; let i = $index; track $index) {
                <button
                  ngbDropdownItem
                  (click)="sortSpacesByOption(option.value)"
                  [class.active]="option.value === spacesStore.selectedSortOption().value"
                  [attr.data-index]="i"
                >
                  {{ option.label }}
                </button>
              }
            </div>
          </div>

          <!-- SHOW DROPDOWN -->
          <div ngbDropdown class="med_show-filter">
            <button
              type="button"
              class="btn btn-clean px-2"
              id="dropdownShow"
              ngbDropdownToggle
              (click)="$event.stopPropagation()"
            >
              <app-icon
                [matIcon]="showingArchivedSpaces ? 'visibility_off' : 'visibility'"
                class="icon-lg icon-active"
              ></app-icon>
            </button>

            <div ngbDropdownMenu aria-labelledby="dropdownShow">
              <button ngbDropdownItem (click)="showActiveSpaces()" [class.active]="!showingArchivedSpaces">
                {{ "active" | translate }}
              </button>
              <button ngbDropdownItem (click)="showArchivedSpaces()" [class.active]="showingArchivedSpaces">
                {{ "archived" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- #Spaces search filter -->
        <button
          class="btn btn-primary btn-sm add-space-btn d-flex justify-content-center align-items-center text-nowrap"
          data-cy="med_add_space_btn"
          (click)="openAddSpaceDialog(); createSpaceTagList = []"
          id="add_space"
        >
          <app-icon icon="plus" class="icon-light" />
          {{ "new_space" | translate | titlecase }}
        </button>
      </ng-container>
    </app-header-bar>
  }
  <!-- #HEADER -->

  <div
    data-cy="med_spaces_wrapper"
    class="med_spaces-wrapper d-flex flex-column justify-conent-center align-items-center"
  >
    @if (
      !spacesStore.spaceLoading() &&
      !spacesStore.isRefreshing() &&
      (spacesStore.filteredSpaces() | filterOptions: ["name"] : spaceFilter)?.length === 0
    ) {
      <div class="med_no-results h-100 d-flex flex-column justify-content-center align-items-center gap-2">
        <img src="assets/images/no-spaces.png" alt="{{ 'no_spaces' | translate }}" class="mb-3" loading="lazy" />
        <h2 class="l-title bold">{{ "no_spaces_found" | translate }}</h2>
        <p class="l-body">{{ "no_spaces_found_description" | translate }}</p>
      </div>
    }
    <div class="container-fluid px-4 pt-3 mt-1 pb-4">
      <div class="med_tags d-flex justify-content-start align-items-center gap-2">
        @for (selectedTag of spacesStore.tagsFilterList(); track selectedTag.uuid) {
          <span
            class="med_tag d-flex justify-content-start align-items-center gap-1 mb-4 text-truncate"
            [ngStyle]="{ 'background-color': selectedTag.color || 'var(--highlight-bg)' }"
            ><span
              class="l-body text-truncate"
              #tagElement
              [matTooltip]="getTooltipText(selectedTag.name, tagElement)"
              matTooltipPosition="above"
              >{{ selectedTag.name }}</span
            >
            <button type="button" class="btn btn-clean p-0" (click)="toggleSelectedTagFilter(selectedTag)">
              <app-icon icon="xmark" class="icon-xs"></app-icon></button
          ></span>
        }
      </div>
      <div class="row">
        @for (
          space of spacesStore.filteredSpaces() | filterOptions: ["name"] : spaceFilter;
          track space.uuid;
          let i = $index
        ) {
          @if (getShowFilteredSpaceByTag(space)) {
            <div class="col-12 col-md-3">
              <app-space-card
                [space]="space"
                [fullTagList]="spacesStore.userTags()"
                [i]="i"
                [tagColorList]="tagColorList"
                (spaceClick)="gotoSpaceDetails($event)"
                (openUpdatePrompt)="openUpdatePrompt($event)"
                (openDeletePrompt)="openDeletePrompt($event)"
                (openArchivePrompt)="openArchivePrompt($event)"
                (openUnarchivePrompt)="openUnarchivePrompt($event)"
                (openClonePrompt)="openClonePrompt($event)"
                (addTagToSpace)="addTagToSpace($event.tag, $event.space)"
                (deleteTagFromSpace)="deleteTagFromSpace($event.tagId, $event.space)"
                (addTag)="addTag($event.tagName, $event.space)"
                (updateTag)="updateTag($event)"
                (deleteTag)="deleteTag($event.tagId, $event.space)"
                (tagsDropdownOpenChange)="onSpaceCardTagsDropdownChange($event)"
              >
              </app-space-card>
            </div>
          }
        }
      </div>
    </div>
  </div>
</section>
<!-- #ADD SPACE MODAL -->
<ng-template #addSpaceDialog>
  <div id="med_add-space-dialog" data-cy="med_add_space_dialog">
    <div class="med_modal-title d-flex align-items-center justify-content-between">
      <h2 class="xs-title bold">{{ "new_space" | translate }}</h2>
      <button type="button" class="btn btn-clean" (click)="closeDialog()">
        <app-icon icon="xmark"></app-icon>
      </button>
    </div>
    <div class="med_dialog-content vstack gap-2" (keydown.enter)="addSpace()">
      <div class="mb-3">
        <label for="space_name" class="form-label">{{ "space_name" | translate }}</label>
        <input
          [(ngModel)]="addSpaceForm.name"
          (ngModelChange)="onNameChange($event)"
          type="text"
          class="form-control"
          id="space_name"
          data-cy="med_space_name_input"
          placeholder="{{ 'enter_space_name' | translate }}"
        />
        @if (showErrors) {
          <p class="xl-body error">
            {{ "space_name_error" | translate }}
          </p>
        }
      </div>
      <div class="mb-1">
        <label for="tagSelect" class="form-label"
          >{{ "tags" | translate }} <small class="fst-italic">({{ "optional" | translate }})</small></label
        >
        <div ngbDropdown class="med_tags med_select" (openChange)="onTagsDropdownOpen($event)">
          <button
            type="button"
            class="form-control d-flex justify-content-between align-items-center"
            id="tagSelect"
            ngbDropdownToggle
          >
            @if (createSpaceTagList.length > 0) {
              <span class="secondary-color">{{ createSpaceTagList.length }} {{ "selected" | translate }}</span>
            } @else {
              <span class="secondary-color">{{ "select_tags" | translate }}</span>
            }
            <app-icon icon="chevron-down" />
          </button>
          <div ngbDropdownMenu aria-labelledby="tagSelect" class="med_tags-dropdown">
            <div
              class="med_tag-header med_tag-header-bg px-3 py-2 border-bottom d-flex justify-content-start align-items-center flex-wrap gap-2"
            >
              @for (tag of createSpaceTagList; track tag.uuid || $index) {
                <span
                  class="med_tag d-flex justify-content-start align-items-center gap-1"
                  [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
                  ><span
                    class="l-body text-truncate"
                    #tagElement
                    [matTooltip]="getTooltipText(tag.name, tagElement)"
                    matTooltipPosition="above"
                    >{{ tag.name }}</span
                  >
                  <button type="button" class="btn btn-clean p-0" (click)="deleteTagFromNewSpaceList(tag.uuid)">
                    <app-icon icon="xmark" class="icon-xs"></app-icon>
                  </button>
                </span>
              }
              @if (createSpaceTagList && createSpaceTagList.length > 0) {
                <input
                  type="text"
                  [(ngModel)]="createFilterTagMenu"
                  class="med_tag-search med_elastic-search form-control border-0 p-0"
                  #filterTagAutofocus
                  (input)="onFilterInputResize($event)"
                />
              }
              @if (createSpaceTagList.length == 0) {
                <input
                  type="text"
                  placeholder="{{ 'search_tag_or_create' | translate }}"
                  [(ngModel)]="createFilterTagMenu"
                  #filterTagAutofocus
                  class="med_tag-search form-control border-0 p-0"
                />
              }
            </div>

            <div class="p-3">
              <div class="d-flex flex-column justify-content-start gap-2">
                @if (createFilterTagMenu && getShowAddButton()) {
                  <button
                    type="button"
                    class="med_tag l-body border cursor-pointer m-0 d-flex align-items-center gap-1 btn btn-clean text-start"
                    (click)="createNewUserTag(createFilterTagMenu)"
                  >
                    {{ "add" | translate }} <span class="med_tag-highlight">"{{ createFilterTagMenu }}"</span>
                  </button>
                }
                @for (tag of getNewSpaceNonAddedTagList(); track tag.uuid) {
                  <button
                    type="button"
                    class="med_tag l-body cursor-pointer text-truncate btn btn-clean p-0 text-start"
                    [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
                    (click)="createFilterTagMenu = ''; addTagToNewSpaceList(tag)"
                    #tagElement
                    [matTooltip]="getTooltipText(tag.name, tagElement)"
                    matTooltipPosition="above"
                  >
                    {{ tag.name }}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="med_tags d-flex justify-content-start align-items-center gap-2 flex-wrap mb-3">
        @for (tag of createSpaceTagList; track tag.uuid || $index) {
          <span
            class="med_tag d-flex justify-content-start align-items-center gap-1"
            [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
          >
            <span
              class="l-body text-truncate"
              #tagElement
              [matTooltip]="getTooltipText(tag.name, tagElement)"
              matTooltipPosition="above"
              >{{ tag.name }}</span
            >
            <button type="button" class="btn btn-clean p-0" (click)="deleteTagFromNewSpaceList(tag.uuid)">
              <app-icon icon="xmark" class="icon-xs"></app-icon>
            </button>
          </span>
        }
      </div>

      <div class="med_p-modal-buttons">
        <button
          class="btn btn-primary w-100"
          (click)="addSpace()"
          [disabled]="showErrors || loading"
          id="add_space_button"
          data-cy="med_create_space_btn"
        >
          {{ "add_space" | translate | titlecase }}
          <span>
            @if (loading) {
              <span class="ms-2 spinner-border text-white" role="status" aria-live="polite"></span>
            }
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- #ADD MEMBER MODAL -->

<!-- Delete dialog -->
<ng-template #deletePrompt>
  <div class="d-flex align-items-center justify-content-between mb-3" data-cy="med_delete_space_modal">
    <h2 class="xs-title bold">{{ "delete_space" | translate }}</h2>
    <app-icon icon="xmark" class="icon med_close-icon" (click)="closeDialog()"></app-icon>
  </div>
  <div class="med_dialog-content vstack gap-2">
    <p class="m-body mb-2">
      {{ "delete_space_confirmation" | translate: { spaceName: selectedSpace.name } }}
    </p>
    <div class="d-flex flex-column gap-2 pt-4">
      <button class="btn btn-danger w-100" (click)="confirmDelete()" data-cy="med_confirm_delete_space_btn">
        {{ "yes_delete_space" | translate }}
      </button>
      <button class="btn btn-link w-100" (click)="closeDialog()">{{ "cancel" | translate | titlecase }}</button>
    </div>
  </div>
</ng-template>

<!-- Edit space modal -->
<ng-template #updateSpaceDialog>
  <div class="d-flex align-items-center justify-content-between mb-3" data-cy="med_edit_space_modal">
    <h2 class="xs-title bold">{{ "edit_space" | translate }}</h2>
    <app-icon icon="xmark" class="icon med_close-icon" (click)="closeDialog()"></app-icon>
  </div>
  <div class="med_dialog-content vstack gap-2" (keydown.enter)="updateSpace()">
    <div class="mb-4">
      <label class="form-label" for="">
        {{ "enter_space_name" | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="selectedSpace.name"
        (ngModelChange)="onNameChange($event)"
        placeholder="{{ 'space_name' | translate }}"
        data-cy="med_edit_space_name_input"
        required
      />
      @if (showErrors) {
        <p class="xl-body error" data-cy="med_edit_space_name_error">
          {{ "space_name_error" | translate }}
        </p>
      }
    </div>
    <div class="d-flex flex-column gap-2 pt-2">
      <button
        class="btn btn-primary w-100 d-flex justify-content-center align-items-center gap-2"
        (click)="updateSpace()"
        [disabled]="showErrors"
        data-cy="med_save_space_changes_btn"
      >
        {{ "save" | translate | titlecase }}
        @if (loading) {
          <span class="ms-2 spinner-border text-white loading-spinner" role="status" aria-live="polite"></span>
        }
      </button>
      <button class="btn btn-link w-100" (click)="closeDialog()" [disabled]="loading">
        {{ "cancel" | translate | titlecase }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Archive dialog -->
<ng-template #archivePrompt>
  <div class="d-flex align-items-center justify-content-between mb-3" data-cy="med_archive_space_modal">
    <h2 class="xs-title bold">{{ "archive_space" | translate }}</h2>
    <app-icon icon="xmark" class="icon med_close-icon" (click)="closeDialog()"></app-icon>
  </div>
  <div class="med_dialog-content vstack gap-2" (keydown.enter)="toggleArchiveSpace(true)">
    <div class="mb-4">
      <p class="m-body mb-2">
        {{ "archive_space_confirmation" | translate: { spaceName: selectedSpace.name } }}
      </p>
    </div>
    <div class="d-flex flex-column gap-2 pt-2">
      <button
        class="btn btn-primary w-100"
        (click)="toggleArchiveSpace(true)"
        data-cy="med_confirm_archive_space_btn"
        [disabled]="loading"
      >
        {{ "archive" | translate | titlecase }}
        @if (loading) {
          <span class="ms-2 spinner-border text-white loading-spinner" role="status" aria-live="polite"></span>
        }
      </button>
      <button class="btn btn-link w-100" (click)="closeDialog()">{{ "cancel" | translate | titlecase }}</button>
    </div>
  </div>
</ng-template>
<!-- #Archive dialog -->

<!-- Unarchive dialog -->
<ng-template #unarchivePrompt>
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h2 class="xs-title bold">{{ "unarchive_space" | translate }}</h2>
    <app-icon icon="xmark" class="icon med_close-icon" (click)="closeDialog()"></app-icon>
  </div>
  <div class="med_dialog-content vstack gap-2" (keydown.enter)="toggleArchiveSpace(false)">
    <div class="mb-4">
      <p class="m-body mb-2">
        {{ "unarchive_space_confirmation" | translate: { spaceName: selectedSpace.name } }}
      </p>
    </div>
    <div class="d-flex flex-column gap-2 pt-2">
      <button
        class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
        (click)="toggleArchiveSpace(false)"
        [disabled]="loading"
      >
        {{ "unarchive" | translate | titlecase }}
        @if (loading) {
          <span class="ms-2 spinner-border text-white loading-spinner" role="status" aria-live="polite"></span>
        }
      </button>
      <button class="btn btn-link w-100" (click)="closeDialog()">{{ "cancel" | translate | titlecase }}</button>
    </div>
  </div>
</ng-template>
<!-- #Unarchive dialog -->

<!-- Clone dialog -->
<ng-template #clonePrompt>
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h2 class="xs-title bold">{{ "clone" | translate }}</h2>
    <app-icon icon="xmark" class="icon med_close-icon" (click)="closeDialog()"></app-icon>
  </div>
  <div class="med_dialog-content vstack gap-2">
    <div class="mb-2">
      <label class="form-label" for="destinationWorkspace">
        {{ "destination_workspace" | translate }}
      </label>
      <p-select
        [options]="workspaces()"
        [(ngModel)]="selectedWorkspace"
        optionLabel="label"
        [disabled]="workspaces().length <= 1"
        id="destinationWorkspace"
        data-cy="med_clone_space_destination_workspace_select"
        placeholder="{{ 'select_destination_workspace' | translate }}"
      />
    </div>
    <div class="mb-4">
      <label class="form-label" for="cloneSpaceName">
        {{ "space_name" | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        id="cloneSpaceName"
        [(ngModel)]="cloneSpaceName"
        (ngModelChange)="onNameChange($event)"
        placeholder="{{ 'enter_space_name' | translate }}"
        data-cy="med_clone_space_name_input"
        required
      />
      @if (showErrors) {
        <p class="xl-body error" data-cy="med_clone_space_name_error">
          {{ "space_name_error" | translate }}
        </p>
      }
    </div>
    <div class="d-flex flex-column gap-2 pt-2 mb-1">
      <button
        class="btn btn-primary w-100"
        (click)="cloneSpace()"
        [disabled]="showErrors || !selectedWorkspace"
        data-cy="med_confirm_clone_space_btn"
      >
        {{ "clone_space" | translate | titlecase }}
      </button>
      <button class="btn btn-link w-100" (click)="closeDialog()">{{ "cancel" | translate | titlecase }}</button>
    </div>
  </div>
</ng-template>
<!-- #Clone dialog -->
